import { RoleEnum } from "types/enums.ts";
import { z } from "zod";

// TODO: Replace with actual generated type once BE ready
export const TEMP_USER_STATE = {
    Pending: "Pending",
    Approved: "Approved",
    Rejected: "Rejected",
} as const;

export type TempUserState = (typeof TEMP_USER_STATE)[keyof typeof TEMP_USER_STATE];

const companyDetails = z.object({
    company: z.string().optional(),
    address: z.string().optional(),
    city: z.string().optional(),
    country: z.string().optional(),
    vat: z.string().optional(),
    invoicing_email: z.string().email("forms.general-validation.invalid_email").optional(),
});

const paymentDetails = z.object({
    bank_account_number: z.string().optional(),
    swift: z.string().optional(),
    bank_code: z.string().optional(),
    bank_name: z.string().optional(),
    bank_address: z.string().optional(),
    bank_note: z.string().optional(),
});

// TODO: Adjust types once BE ready. All set to optional for now.
export const schema = z.object({
    // Info
    nickname: z.string().optional(),
    email: z.string().email("forms.general-validation.invalid_email").optional(),
    phone: z.number().optional(),
    name: z.string().optional(),
    surname: z.string().optional(),
    websites: z.array(z.string()).optional(),
    send_invitation: z.boolean().optional(),

    // Settings
    country_id: z.number().optional(),
    language_id: z.number().optional(),
    currency_id: z.number().optional(),
    user_id: z.number().optional(),
    state: z.enum(Object.values(TEMP_USER_STATE) as [TempUserState, ...TempUserState[]]).optional(),
    manager: z.string().optional(),
    user_api_token: z.string().optional(),
    note: z.string().optional(),
    commission_group_id: z.string().optional(),
    role: z.nativeEnum(RoleEnum),
    categories: z.array(z.string()).optional(),
    labels: z.array(z.string()).optional(),
    permitted_private_offers: z.array(z.string()).optional(),

    // Company info
    company_details: z.array(companyDetails).optional(),

    // Bank info
    payment_details: z.array(paymentDetails).optional(),
});

export type UserEditFormData = z.infer<typeof schema>;
